import { api, setConfig } from '../..';
import { mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

interface UserType {
	email: string;
	password: string;
}

export const logIn = (user: UserType): Promise<PropertyType> =>
	api.post<PropertyType>('/login', user, setConfig(user)).then((res) => {
		return mapApiToEntity(res.data);
	});

export const checkLoginType = (): Promise<string> =>
	api.post<PropertyType>('/check-login-type').then((res) => {
		return res.data.loginType;
	});
